import { StoredVoiceDraft } from '../model/types'

const DB_NAME = 'rtu-voice-message-drafts'
const DB_VERSION = 1
const STORE_NAME = 'drafts'

const openDb = (): Promise<IDBDatabase> => {
  return new Promise((resolve, reject) => {
    if (typeof indexedDB === 'undefined') {
      reject(new Error('IndexedDB is not available'))
      return
    }

    const request = indexedDB.open(DB_NAME, DB_VERSION)
    request.onupgradeneeded = () => {
      const db = request.result
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: 'pServed' })
      }
    }
    request.onsuccess = () => resolve(request.result)
    request.onerror = () => reject(request.error)
  })
}

export const saveVoiceDraft = async (draft: StoredVoiceDraft): Promise<void> => {
  const db = await openDb()

  await new Promise<void>((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readwrite')
    tx.objectStore(STORE_NAME).put(draft)
    tx.oncomplete = () => resolve()
    tx.onerror = () => reject(tx.error)
  })

  db.close()
}

export const loadVoiceDraft = async (pServed: string): Promise<StoredVoiceDraft | undefined> => {
  const db = await openDb()

  const draft = await new Promise<StoredVoiceDraft | undefined>((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readonly')
    const request = tx.objectStore(STORE_NAME).get(pServed)
    request.onsuccess = () => resolve(request.result as StoredVoiceDraft | undefined)
    request.onerror = () => reject(request.error)
  })

  db.close()
  return draft
}

export const deleteVoiceDraft = async (pServed: string): Promise<void> => {
  const db = await openDb()

  await new Promise<void>((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readwrite')
    tx.objectStore(STORE_NAME).delete(pServed)
    tx.oncomplete = () => resolve()
    tx.onerror = () => reject(tx.error)
  })

  db.close()
}
